export class HttpHandler {
  private httpClient: any;

  constructor(httpClient: any) {
    this.httpClient = httpClient;
  }

  get<T>(url: string, params?: any): Promise<T> {
    return this.httpClient.get(url, {params})
      .then((response: any) => {
        if (response) {
          return Promise.resolve(response.data);
        } else {
          throw Error();
        }
      });
  }

  post<T>(url: string, requestContent: T): Promise<any> {
    return this.httpClient.post(url, JSON.stringify(requestContent));
  }

  put<T>(url: string, requestContent: T): Promise<any> {
    return this.httpClient.put(url, JSON.stringify(requestContent));
  }

  delete(url: string): Promise<any> {
    return this.httpClient.delete(url);
  }
}
